// extracted by mini-css-extract-plugin
export default {"p":"cfd1796b21 _556b71af94 e6c1e85a17","clr":"_7457a149e5","dls":"d95fa2bcc7"};